import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUser } from 'contexts/UserContext';
import MainLayout from 'pages/principal/MainLayout';
import ChronosLayout from 'pages/principal/ChronosLayout';


const ProtectedRoute = () => {
  const { user, loadingUser, loadConfigFromStorage } = useUser();
  const [config, setConfig] = useState(null);
  const [loadingConfig, setLoadingConfig] = useState(true);

  const location = useLocation();

  useEffect(() => {
    const fetchConfig = async () => {
      const result = await loadConfigFromStorage();
      setConfig(result);
      setLoadingConfig(false);
    };
    fetchConfig();
  }, []);

  const hasTerminal = Boolean(config?.terminalId);    // si existe terminal configurada
  const isAuthenticated = Boolean(user && user.id > 0); // usuario válido
  

  
  // 1) Cargando
  if (loadingUser || loadingConfig) {
    return <div>Cargando...</div>;
  }

  if (isAuthenticated&&!hasTerminal) {
   return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
    
  }



  // ---------------------------
  // 2) No hay terminal → LOGIN
  // ---------------------------
  if (!hasTerminal) {
    if (location.pathname !== "/login") {
      return <Navigate to="/login" replace />;
    }
    return <Outlet />; // Renderiza la página /login
  }

  // ----------------------------------------
  // 3) Hay terminal, pero NO hay usuario → START
  // ----------------------------------------
  if (!isAuthenticated) {
    if (location.pathname !== "/start") {
      return <Navigate to="/start" replace />;
    }
    return <Navigate to="/start" replace />;
  }

  if(user.presencia==="X" && user.planta==="")
  {
   return (
    <ChronosLayout>
      <Outlet />
    </ChronosLayout>
   );

  }
  // ----------------------------------------
  // 4) Terminal OK + Usuario OK → Páginas privadas
  // ----------------------------------------
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  );
};

export default React.memo(ProtectedRoute);
